// src/components/Navigation.tsx
import React, { useState } from 'react';
import styled from 'styled-components';

const Nav = styled.nav`
  position: fixed;
  top: 20px;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  z-index: 999;
`;

const Container = styled.div`
  max-width: 1080px;
  width: calc(100% - 32px);
  margin: 0 auto;
  padding: 12px 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(255, 255, 255, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.6);
  box-shadow: 0 20px 40px rgba(15, 28, 45, 0.15);
  backdrop-filter: blur(12px);
  border-radius: 18px;

  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
  }
`;

const NavbarHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const NavbarBrand = styled.a`
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #0f1c2d;
  font-weight: 700;
  font-size: 18px;
`;

const LogoImage = styled.img`
  height: 32px;
  width: auto;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.25));
`;

const NavbarToggle = styled.button`
  background: none;
  border: 1px solid #d4dde8;
  font-size: 22px;
  cursor: pointer;
  display: none;
  color: #0f1c2d;
  padding: 6px 10px;
  border-radius: 10px;

  @media (max-width: 767px) {
    display: block;
  }
`;

const NavbarCollapse = styled.div<{ open: boolean }>`
  display: ${({ open }) => (open ? 'block' : 'none')};

  @media (min-width: 768px) {
    display: contents !important;
  }
`;

const CtaWrap = styled.div`
  margin-top: 8px;

  @media (min-width: 768px) {
    margin-top: 0;
    justify-self: end;
  }
`;

const NavUl = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;

  @media (min-width: 768px) {
    display: flex;
    align-items: center;
  }
`;

const NavLi = styled.li`
  margin: 0;

  @media (min-width: 768px) {
    margin-left: 12px;
  }
`;

const NavLink = styled.a`
  color: #0f1c2d;
  font-size: 14px;
  font-weight: 700;
  text-decoration: none;
  padding: 10px 14px;
  display: block;
  border-radius: 12px;
  transition: background 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.8);
    box-shadow: 0 8px 20px rgba(15, 28, 45, 0.12);
  }
`;

const PrimaryButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 16px;
  border-radius: 12px;
  background: #0f1c2d;
  color: #f7fbff;
  text-decoration: none;
  font-size: 16px;
  font-weight: 700;
  box-shadow: 0 10px 22px rgba(15, 28, 45, 0.2);
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 14px 28px rgba(56, 95, 146, 0.25);
    color: #f7fbff;
  }
`;

const Navigation: React.FC = () => {
  const [navbarOpen, setNavbarOpen] = useState(false);

  const handleToggle = () => {
    setNavbarOpen(!navbarOpen);
  };

  return (
    <Nav>
      <Container>
        <NavbarHeader>
          <NavbarBrand href="/">
            {/* Replace text with logo image */}
            <LogoImage src={require('../assets/images/BlackLogoNoBG.png')} alt="Logo" />
          </NavbarBrand>
          <NavbarToggle onClick={handleToggle}>
            &#9776;
          </NavbarToggle>
        </NavbarHeader>
        <NavbarCollapse open={navbarOpen}>
          <NavUl>
            {/* <NavLi>
              <NavLink href="/">Home</NavLink>
            </NavLi> */}
            <NavLi>
              <NavLink href="/products/">Products</NavLink>
            </NavLi>
            <NavLi>
              <NavLink href="/about/">About</NavLink>
            </NavLi>
            <NavLi>
              <NavLink href="/blog/">Blog</NavLink>
            </NavLi>
          </NavUl>
          <CtaWrap>
            <PrimaryButton href="/contact-us/">Contact us</PrimaryButton>
          </CtaWrap>
        </NavbarCollapse>
      </Container>
    </Nav>
  );
};

export default Navigation;
